import { httpClient } from "../http/httpClient";

export async function deleteAllConsults(): Promise<void> {
  await httpClient.delete("/consults");
}
